'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  en: {
    event: {
      date: {
        past_event: 'Past event',
        ongoing_event: 'Ongoing event'
      },
      price: {
        free: 'Free'
      },
      timezone: 'Timezone: {{timezone}}'
    },
    workshops: {
      activities: 'Activities',
      speakers: 'Speakers',
      speaker: 'Speaker',
      schedule: 'Schedule',
      selectCategory: 'Choose a category',
      category: 'Category'
    },
    sponsors: {
      companyDescription: 'Company description',
      modalTitle: 'Sponsor information',
      title: 'Sponsors'
    },
    speakers: {
      keywords: 'Keywords',
      noSpeakers: 'No speakers',
      empty_bio: 'The speaker has no biography.'
    },
    b2b: {
      create_conference_and_participant: 'Please create a conference and a least one participant'
    },
    text: {
      see_less: 'See less',
      read_more: 'Read more',
      less_info: 'Less info',
      more_info: "More info",
      click_here_file: "Click here to view the file",
      no_iframe_src: "Please set the url for the iframe"
    },
    date: {
      available_date: 'Available Dates',
      to: 'to',
      starts_at: 'Starts at',
      ends_at: 'Ends at',
      from_optional: '',
      units: {
        plural: {
          days: 'days',
          hours: 'hours',
          minutes: 'minutes',
          seconds: 'seconds'
        }
      }
    },
    exhibitors: {
      search: 'search',
      reset: 'reset'
    },
    registration: {
      sign_up: 'Sign up',
      type: 'Type',
      price: 'Price',
      register: 'Register',
      soldOut: 'Sold out',
      info: 'Select your plan and continue on the sign up button by entering your personal details',
      available_seats: 'Availability',
      no_limit: 'No limit',
      attendee_not_found: "We didn't find any record with the provided email.",
      unable_to_modify: "We're sorry the organizer does not allow updates to your registration.",
      general_error: "The mail couldn't be sent. Try again later.",
      continue_registration: "Continue registration",
      already_registered_info: "If you are already registered for this event and want to edit your information, please enter your email address.",
      already_registered_title: "Already registered?",
      mail_sent: "A link to edit your registration information has been sent to your email."
    },
    contact_form: {
      success_message: "The message was sent successfully",
      full_name: 'Full name',
      email: 'Email',
      message: 'Message'
    },
    cookie_consent: {
      privacy_policy: 'Privacy policy',
      explanation: 'This website stores cookies on your computer. These cookies are used to improve your website and provide more personalized services to you, both on this website and through other media.',
      block_information: 'The modal box will be displayed at the bottom of the page'
    },
    map: {
      not_location: "Please assign a location in the event configuration."
    },
    buttons: {
      submit: 'Submit',
      onlyEssential: 'Only essential ones',
      got_it: 'Got it'
    }
  },
  es: {
    event: {
      date: {
        past_event: "Evento Pasado",
        ongoing_event: "Evento en Curso"
      },
      price: {
        free: "Gratis"
      },
      timezone: "Zona horaria: {{timezone}}"
    },
    workshops: {
      activities: "Actividades",
      speakers: "Ponentes",
      speaker: "Ponente",
      schedule: "Programa",
      selectCategory: "Elegir una categoría",
      category: "Categoría"
    },
    sponsors: {
      companyDescription: "Descripción de la compañía",
      modalTitle: "Información del patrocinador",
      title: "Patrocinadores"
    },
    speakers: {
      keywords: "Palabras clave",
      noSpeakers: "Sin ponentes",
      empty_bio: "El ponente no tiene biografía."
    },
    b2b: {
      create_conference_and_participant: "Por favor crea una rueda de negocios y al menos un participante"
    },
    text: {
      see_less: "Ver menos",
      read_more: "Leer más",
      less_info: "Menos información",
      more_info: "Más información",
      click_here_file: "Haz clic aquí para ver el archivo",
      no_iframe_src: "Por favor establece la URL para el iframe"
    },
    date: {
      available_date: "Fechas Disponibles",
      to: "a",
      starts_at: "Inicia a las",
      ends_at: "Termina a las",
      from_optional: "",
      units: {
        plural: {
          days: "días",
          hours: "horas",
          minutes: "minutos",
          seconds: "segundos"
        }
      }
    },
    exhibitors: {
      search: "buscar",
      reset: "restablecer"
    },
    registration: {
      sign_up: "Registrarse",
      type: "Tipo",
      price: "Precio",
      register: "Registro",
      soldOut: "Agotado",
      info: "Selecciona tu plan y continúa en el botón de registro ingresando tus datos personales",
      available_seats: "Disponibilidad",
      no_limit: "Sin límite",
      attendee_not_found: "No encontramos ningún registro con el correo electrónico proporcionado.",
      unable_to_modify: "Lo sentimos, el organizador no permite la modificación de tu registro.",
      general_error: "El correo no se pudo enviar. Inténtalo de nuevo más tarde.",
      continue_registration: "Continuar registro",
      already_registered_info: "Si ya estás registrado para este evento y deseas editar tu información, por favor ingresa tu dirección de correo electrónico.",
      already_registered_title: "¿Ya estás registrado?",
      mail_sent: "Se ha enviado un enlace para editar tu información de registro a tu correo electrónico."
    },
    contact_form: {
      success_message: "El mensaje se envió con éxito",
      full_name: "Nombre completo",
      email: "Correo electrónico",
      message: "Mensaje"
    },
    cookie_consent: {
      privacy_policy: "Política de privacidad",
      explanation: "Este sitio web almacena cookies en tu computadora. Estas cookies se utilizan para mejorar tu sitio web y ofrecerte servicios más personalizados, tanto en este sitio como a través de otros medios.",
      block_information: "El mensaje informativo se mostrará en la parte inferior de la página"
    },
    map: {
      not_location: "Por favor asigna una ubicación en la configuración del evento."
    },
    buttons: {
      submit: "Enviar",
      onlyEssential: "Solo esenciales",
      got_it: "Entendido"
    }
  },
  fr: {
    event: {
      date: {
        past_event: "Événement passé",
        ongoing_event: "Événement en cours"
      },
      price: {
        free: "Gratuit"
      },
      timezone: "Fuseau horaire : {{timezone}}"
    },
    workshops: {
      activities: "Activités",
      speakers: "Intervenants",
      speaker: "Intervenant",
      schedule: "Programme",
      selectCategory: "Choisissez une catégorie",
      category: "Catégorie"
    },
    sponsors: {
      companyDescription: "Description de l'entreprise",
      modalTitle: "Informations sur le sponsor",
      title: "Sponsors"
    },
    speakers: {
      keywords: "Mots-clés",
      noSpeakers: "Pas de conférenciers",
      empty_bio: "L'intervenant n'a pas de biographie."
    },
    b2b: {
      create_conference_and_participant: "Veuillez créer une conférence et au moins un participant."
    },
    text: {
      see_less: "Voir moins",
      read_more: "Lire la suite",
      less_info: "Moins d'infos",
      more_info: "Plus d'infos",
      click_here_file: "Cliquez ici pour voir le fichier",
      no_iframe_src: "Veuillez définir l'URL pour l'iframe."
    },
    date: {
      available_date: "Dates disponibles",
      to: "à",
      starts_at: "Commence à",
      ends_at: "Se termine à",
      from_optional: "",
      units: {
        plural: {
          days: "jours",
          hours: "heures",
          minutes: "minutes",
          seconds: "secondes"
        }
      }
    },
    exhibitors: {
      search: "rechercher",
      reset: "réinitialiser"
    },
    registration: {
      sign_up: "Inscrivez-vous",
      type: "Type",
      price: "Prix",
      register: "S'inscrire",
      soldOut: "Épuisé",
      info: "Sélectionnez votre plan et continuez sur le bouton d'inscription en entrant vos données personnelles.",
      available_seats: "Disponibilité",
      no_limit: "Pas de limite",
      attendee_not_found: "Nous n'avons trouvé aucun enregistrement avec l'email fourni.",
      unable_to_modify: "Désolé, l'organisateur ne permet pas de modifier votre inscription.",
      general_error: "Le mail n'a pas pu être envoyé. Réessayez plus tard.",
      continue_registration: "Continuer l'inscription",
      already_registered_info: "Si vous êtes déjà inscrit à cet événement et souhaitez modifier vos informations, veuillez saisir votre adresse email.",
      already_registered_title: "Déjà inscrit ?",
      mail_sent: "Un lien pour modifier vos informations d'inscription a été envoyé à votre email."
    },
    contact_form: {
      success_message: "Le message a été envoyé avec succès.",
      full_name: "Nom complet",
      email: "Email",
      message: "Message"
    },
    cookie_consent: {
      privacy_policy: "Politique de confidentialité",
      explanation: "Ce site web stocke des cookies sur votre ordinateur. Ces cookies sont utilisés pour améliorer votre site web et fournir des services plus personnalisés, à la fois sur ce site et via d'autres médias.",
      block_information: "La boîte modale sera affichée en bas de la page."
    },
    map: {
      not_location: "Veuillez attribuer un emplacement dans la configuration de l'événement."
    },
    buttons: {
      submit: "Soumettre",
      onlyEssential: "Uniquement essentiels",
      got_it: "Compris"
    }
  },
  de: {
    event: {
      date: {
        past_event: "Vergangene Veranstaltung",
        ongoing_event: "Aktuelle Veranstaltung"
      },
      price: {
        free: "Kostenlos"
      },
      timezone: "Zeitzone: {{timezone}}"
    },
    workshops: {
      activities: "Aktivitäten",
      speakers: "Referenten",
      speaker: "Referent",
      schedule: "Zeitplan",
      selectCategory: "Wählen Sie eine Kategorie aus",
      category: "Kategorie"
    },
    sponsors: {
      companyDescription: "Unternehmensbeschreibung",
      modalTitle: "Sponsorinformationen",
      title: "Sponsoren"
    },
    speakers: {
      keywords: "Schlüsselwörter",
      noSpeakers: "Keine Sprecher",
      empty_bio: "Der Referent hat keine Biografie."
    },
    b2b: {
      create_conference_and_participant: "Bitte erstellen Sie eine Konferenz und einen Teilnehmer."
    },
    text: {
      see_less: "Weniger anzeigen",
      read_more: "Mehr lesen",
      less_info: "Weniger Informationen",
      more_info: "Mehr Informationen",
      click_here_file: "Klicken Sie hier, um die Datei anzuzeigen",
      no_iframe_src: "Bitte setzen Sie die URL für das iFrame."
    },
    date: {
      available_date: "Verfügbare Daten",
      to: "bis",
      starts_at: "Beginnt um",
      ends_at: "Endet um",
      from_optional: "",
      units: {
        plural: {
          days: "Tage",
          hours: "Stunden",
          minutes: "Minuten",
          seconds: "Sekunden"
        }
      }
    },
    exhibitors: {
      search: "suchen",
      reset: "zurücksetzen"
    },
    registration: {
      sign_up: "Anmelden",
      type: "Typ",
      price: "Preis",
      register: "Registrieren",
      soldOut: "Ausgebucht",
      info: "Wählen Sie Ihren Plan aus und fahren Sie mit dem Anmeldebutton fort, indem Sie Ihre persönlichen Daten eingeben.",
      available_seats: "Verfügbarkeit",
      no_limit: "Kein Limit",
      attendee_not_found: "Wir haben keinen Datensatz mit der angegebenen E-Mail gefunden.",
      unable_to_modify: "Es tut uns leid, der Organisator erlaubt keine Änderungen an Ihrer Registrierung.",
      general_error: "Die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.",
      continue_registration: "Registrierung fortsetzen",
      already_registered_info: "Wenn Sie bereits für diese Veranstaltung registriert sind und Ihre Informationen bearbeiten möchten, geben Sie bitte Ihre E-Mail-Adresse ein.",
      already_registered_title: "Bereits registriert?",
      mail_sent: "Ein Link zur Bearbeitung Ihrer Registrierungsinformationen wurde an Ihre E-Mail gesendet."
    },
    contact_form: {
      success_message: "Die Nachricht wurde erfolgreich gesendet.",
      full_name: "Vollständiger Name",
      email: "E-Mail",
      message: "Nachricht"
    },
    cookie_consent: {
      privacy_policy: "Datenschutzbestimmungen",
      explanation: "Diese Website speichert Cookies auf Ihrem Computer. Diese Cookies werden verwendet, um Ihre Website zu verbessern und Ihnen sowohl auf dieser Website als auch über andere Medien personalisierte Dienste anzubieten.",
      block_information: "Das Modal wird am unteren Rand der Seite angezeigt."
    },
    map: {
      not_location: "Bitte weisen Sie einen Standort in der Veranstaltungsdefinition zu."
    },
    buttons: {
      submit: "Einreichen",
      onlyEssential: "Nur essentielle",
      got_it: "Verstanden"
    }
  },
  it: {
    event: {
      date: {
        past_event: "Evento passato",
        ongoing_event: "Evento in corso"
      },
      price: {
        free: "Gratuito"
      },
      timezone: "Fuso orario: {{timezone}}"
    },
    workshops: {
      activities: "Attività",
      speakers: "Relatori",
      speaker: "Relatore",
      schedule: "Programma",
      selectCategory: "Scegli una categoria",
      category: "Categoria"
    },
    sponsors: {
      companyDescription: "Descrizione dell'azienda",
      modalTitle: "Informazioni sugli sponsor",
      title: "Sponsor"
    },
    speakers: {
      keywords: "Parole chiave",
      noSpeakers: "Nessun relatore",
      empty_bio: "Il relatore non ha una biografia."
    },
    b2b: {
      create_conference_and_participant: "Si prega di creare una conferenza e almeno un partecipante"
    },
    text: {
      see_less: "Vedi meno",
      read_more: "Leggi di più",
      less_info: "Meno informazioni",
      more_info: "Più informazioni",
      click_here_file: "Clicca qui per visualizzare il file",
      no_iframe_src: "Imposta l'URL per l'iframe"
    },
    date: {
      available_date: "Date disponibili",
      to: "a",
      starts_at: "Inizia alle",
      ends_at: "Finisce alle",
      from_optional: "",
      units: {
        plural: {
          days: "giorni",
          hours: "ore",
          minutes: "minuti",
          seconds: "secondi"
        }
      }
    },
    exhibitors: {
      search: "cerca",
      reset: "ripristina"
    },
    registration: {
      sign_up: "Iscriviti",
      type: "Tipo",
      price: "Prezzo",
      register: "Registrati",
      soldOut: "Esaurito",
      info: "Seleziona il tuo piano e continua con il pulsante di iscrizione inserendo i tuoi dati personali",
      available_seats: "Disponibilità",
      no_limit: "Nessun limite",
      attendee_not_found: "Non abbiamo trovato alcun record con l'email fornita.",
      unable_to_modify: "Ci dispiace, l'organizzatore non consente aggiornamenti alla tua registrazione.",
      general_error: "L'email non può essere inviata. Riprova più tardi.",
      continue_registration: "Continua registrazione",
      already_registered_info: "Se sei già registrato per questo evento e vuoi modificare le tue informazioni, inserisci il tuo indirizzo email.",
      already_registered_title: "Già registrato?",
      mail_sent: "Un link per modificare le tue informazioni di registrazione è stato inviato alla tua email."
    },
    contact_form: {
      success_message: "Il messaggio è stato inviato con successo",
      full_name: "Nome completo",
      email: "Email",
      message: "Messaggio"
    },
    cookie_consent: {
      privacy_policy: "Informativa sulla privacy",
      explanation: "Questo sito web memorizza i cookie sul tuo computer. Questi cookie vengono utilizzati per migliorare il tuo sito web e fornirti servizi più personalizzati, sia su questo sito che attraverso altri media.",
      block_information: "La finestra modale verrà visualizzata nella parte inferiore della pagina"
    },
    map: {
      not_location: "Si prega di assegnare una posizione nella configurazione dell'evento."
    },
    buttons: {
      submit: "Invia",
      onlyEssential: "Solo essenziali",
      got_it: "Capito"
    }
  },
  pt: {
    event: {
      date: {
        past_event: "Evento passado",
        ongoing_event: "Evento em andamento"
      },
      price: {
        free: "Grátis"
      },
      timezone: "Fuso horário: {{timezone}}"
    },
    workshops: {
      activities: "Atividades",
      speakers: "Palestrantes",
      speaker: "Palestrante",
      schedule: "Agenda",
      selectCategory: "Escolha uma categoria",
      category: "Categoria"
    },
    sponsors: {
      companyDescription: "Descrição da empresa",
      modalTitle: "Informações do patrocinador",
      title: "Patrocinadores"
    },
    speakers: {
      keywords: "Palavras-chave",
      noSpeakers: "Nenhum palestrante",
      empty_bio: "O palestrante não tem biografia."
    },
    b2b: {
      create_conference_and_participant: "Por favor, crie uma conferência e pelo menos um participante"
    },
    text: {
      see_less: "Ver menos",
      read_more: "Leia mais",
      less_info: "Menos informações",
      more_info: "Mais informações",
      click_here_file: "Clique aqui para visualizar o arquivo",
      no_iframe_src: "Por favor, defina a URL para o iframe"
    },
    date: {
      available_date: "Datas Disponíveis",
      to: "até",
      starts_at: "Começa às",
      ends_at: "Termina às",
      from_optional: "",
      units: {
        plural: {
          days: "dias",
          hours: "horas",
          minutes: "minutos",
          seconds: "segundos"
        }
      }
    },
    exhibitors: {
      search: "pesquisar",
      reset: "resetar"
    },
    registration: {
      sign_up: "Inscrever-se",
      type: "Tipo",
      price: "Preço",
      register: "Registrar",
      soldOut: "Esgotado",
      info: "Selecione seu plano e continue no botão de inscrição inserindo seus dados pessoais",
      available_seats: "Disponibilidade",
      no_limit: "Sem limite",
      attendee_not_found: "Não encontramos nenhum registro com o e-mail fornecido.",
      unable_to_modify: "Desculpe, o organizador não permite atualizações na sua inscrição.",
      general_error: "O e-mail não pôde ser enviado. Tente novamente mais tarde.",
      continue_registration: "Continuar registro",
      already_registered_info: "Se você já está registrado para este evento e deseja editar suas informações, insira seu endereço de e-mail.",
      already_registered_title: "Já registrado?",
      mail_sent: "Um link para editar suas informações de registro foi enviado para seu e-mail."
    },
    contact_form: {
      success_message: "A mensagem foi enviada com sucesso",
      full_name: "Nome completo",
      email: "E-mail",
      message: "Mensagem"
    },
    cookie_consent: {
      privacy_policy: "Política de privacidade",
      explanation: "Este site armazena cookies no seu computador. Esses cookies são usados para melhorar o seu site e fornecer serviços mais personalizados, tanto neste site quanto por meio de outros meios.",
      block_information: "A caixa modal será exibida na parte inferior da página"
    },
    map: {
      not_location: "Por favor, atribua uma localização na configuração do evento."
    },
    buttons: {
      submit: "Enviar",
      onlyEssential: "Apenas essenciais",
      got_it: "Entendi"
    }
  },
  ca: {
    event: {
      date: {
        past_event: "Esdeveniment passat",
        ongoing_event: "Esdeveniment en curs"
      },
      price: {
        free: "Gratuït"
      },
      timezone: "Zona horària: {{timezone}}"
    },
    workshops: {
      activities: "Activitats",
      speakers: "Ponents",
      speaker: "Ponent",
      schedule: "Horari",
      selectCategory: "Trieu una categoria",
      category: "Categoria"
    },
    sponsors: {
      companyDescription: "Descripció de l'empresa",
      modalTitle: "Informació del patrocinador",
      title: "Patrocinadors"
    },
    speakers: {
      keywords: "Paraules clau",
      noSpeakers: "Sense ponents",
      empty_bio: "El ponent no té biografia."
    },
    b2b: {
      create_conference_and_participant: "Si us plau, creeu una conferència i almenys un participant"
    },
    text: {
      see_less: "Veure menys",
      read_more: "Llegir més",
      less_info: "Menys info",
      more_info: "Més info",
      click_here_file: "Feu clic aquí per veure el fitxer",
      no_iframe_src: "Si us plau, configureu l'url per a l'iframe"
    },
    date: {
      available_date: "Dates disponibles",
      to: "a",
      starts_at: "Comença a",
      ends_at: "Acaba a",
      from_optional: "",
      units: {
        plural: {
          days: "dies",
          hours: "hores",
          minutes: "minuts",
          seconds: "segons"
        }
      }
    },
    exhibitors: {
      search: "cerca",
      reset: "reiniciar"
    },
    registration: {
      sign_up: "Inscriure's",
      type: "Tipus",
      price: "Preu",
      register: "Registrar-se",
      soldOut: "Exhaurit",
      info: "Seleccioneu el vostre pla i continueu al botó d'inscripció introduint les vostres dades personals",
      available_seats: "Disponibilitat",
      no_limit: "Sense límit",
      attendee_not_found: "No hem trobat cap registre amb l'email proporcionat.",
      unable_to_modify: "Ho sentim, l'organitzador no permet actualitzacions de la vostra inscripció.",
      general_error: "El correu no s'ha pogut enviar. Torneu-ho a provar més tard.",
      continue_registration: "Continuar registre",
      already_registered_info: "Si ja esteu registrat per aquest esdeveniment i voleu editar la vostra informació, si us plau, introduïu la vostra adreça de correu electrònic.",
      already_registered_title: "Ja registrat?",
      mail_sent: "S'ha enviat un enllaç per editar la vostra informació d'inscripció al vostre correu electrònic."
    },
    contact_form: {
      success_message: "El missatge s'ha enviat correctament",
      full_name: "Nom complet",
      email: "Correu electrònic",
      message: "Missatge"
    },
    cookie_consent: {
      privacy_policy: "Política de privadesa",
      explanation: "Aquest lloc web emmagatzema galetes al vostre ordenador. Aquestes galetes s'utilitzen per millorar el vostre lloc web i oferir serveis més personalitzats, tant en aquest lloc com a través d'altres mitjans.",
      block_information: "La finestra modal es mostrarà a la part inferior de la pàgina"
    },
    map: {
      not_location: "Si us plau, assigna una ubicació a la configuració de l'esdeveniment."
    },
    buttons: {
      submit: "Enviar",
      onlyEssential: "Només els essencials",
      got_it: "Entesos"
    }
  },
  nl: {
    event: {
      date: {
        past_event: "Verleden evenement",
        ongoing_event: "Lopend evenement"
      },
      price: {
        free: "Gratis"
      },
      timezone: "Tijdzone: {{timezone}}"
    },
    workshops: {
      activities: "Activiteiten",
      speakers: "Sprekers",
      speaker: "Spreker",
      schedule: "Schema",
      selectCategory: "Kies een categorie",
      category: "Categorie"
    },
    sponsors: {
      companyDescription: "Bedrijfsbeschrijving",
      modalTitle: "Sponsorinformatie",
      title: "Sponsoren"
    },
    speakers: {
      keywords: "Sleutelwoorden",
      noSpeakers: "Geen sprekers",
      empty_bio: "De spreker heeft geen biografie."
    },
    b2b: {
      create_conference_and_participant: "Maak alsjeblieft een conferentie en minimaal één deelnemer aan"
    },
    text: {
      see_less: "Zie minder",
      read_more: "Lees meer",
      less_info: "Minder info",
      more_info: "Meer info",
      click_here_file: "Klik hier om het bestand te bekijken",
      no_iframe_src: "Stel a.u.b. de URL voor de iframe in"
    },
    date: {
      available_date: "Beschikbare data",
      to: "tot",
      starts_at: "Begint om",
      ends_at: "Eindigt om",
      from_optional: "",
      units: {
        plural: {
          days: "dagen",
          hours: "uren",
          minutes: "minuten",
          seconds: "seconden"
        }
      }
    },
    exhibitors: {
      search: "zoeken",
      reset: "resetten"
    },
    registration: {
      sign_up: "Aanmelden",
      type: "Type",
      price: "Prijs",
      register: "Registreren",
      soldOut: "Uitverkocht",
      info: "Selecteer je plan en ga door op de aanmeldknop door je persoonlijke gegevens in te voeren",
      available_seats: "Beschikbaarheid",
      no_limit: "Geen limiet",
      attendee_not_found: "We hebben geen registratie gevonden met het opgegeven e-mailadres.",
      unable_to_modify: "Het spijt ons, de organisator staat geen wijzigingen toe aan je registratie.",
      general_error: "De mail kon niet worden verzonden. Probeer het later opnieuw.",
      continue_registration: "Registratie vervolgen",
      already_registered_info: "Als je al geregistreerd bent voor dit evenement en je wilt je informatie bewerken, voer dan je e-mailadres in.",
      already_registered_title: "Al geregistreerd?",
      mail_sent: "Een link om je registratie-informatie te bewerken is naar je e-mail verzonden."
    },
    contact_form: {
      success_message: "Het bericht is succesvol verzonden",
      full_name: "Volledige naam",
      email: "E-mail",
      message: "Bericht"
    },
    cookie_consent: {
      privacy_policy: "Privacybeleid",
      explanation: "Deze website slaat cookies op je computer op. Deze cookies worden gebruikt om je website te verbeteren en meer gepersonaliseerde diensten aan te bieden, zowel op deze website als via andere media.",
      block_information: "De modal box wordt onderaan de pagina weergegeven"
    },
    map: {
      not_location: "Stel a.u.b. een locatie in de evenementconfiguratie in."
    },
    buttons: {
      submit: "Verzenden",
      onlyEssential: "Alleen essentiële",
      got_it: "Got it"
    }
  },
  ar: {
    event: {
      date: {
        past_event: "فعالية سابقة",
        ongoing_event: "فعالية جارية"
      },
      price: {
        free: "مجاني"
      },
      timezone: "المنطقة الزمنية: {{timezone}}"
    },
    workshops: {
      activities: "الأنشطة",
      speakers: "المتحدثون",
      speaker: "متحدث",
      schedule: "الجدول الزمني",
      selectCategory: "اختر فئة",
      category: "فئة"
    },
    sponsors: {
      companyDescription: "وصف الشركة",
      modalTitle: "معلومات الراعي",
      title: "الرعاة"
    },
    speakers: {
      keywords: "الكلمات الرئيسية",
      noSpeakers: "لا يوجد متحدثون",
      empty_bio: "لا يوجد سيرة ذاتية للمتحدث."
    },
    b2b: {
      create_conference_and_participant: "يرجى إنشاء مؤتمر ومشارك واحد على الأقل"
    },
    text: {
      see_less: "رؤية أقل",
      read_more: "اقرأ المزيد",
      less_info: "معلومات أقل",
      more_info: "مزيد من المعلومات",
      click_here_file: "اضغط هنا لمشاهدة الملف",
      no_iframe_src: "يرجى تعيين URL لـ Iframe"
    },
    date: {
      available_date: "التواريخ المتاحة",
      to: "إلى",
      starts_at: "يبدأ في",
      ends_at: "ينتهي في",
      from_optional: "",
      units: {
        plural: {
          days: "أيام",
          hours: "ساعات",
          minutes: "دقائق",
          seconds: "ثواني"
        }
      }
    },
    exhibitors: {
      search: "بحث",
      reset: "إعادة تعيين"
    },
    registration: {
      sign_up: "سجل الآن",
      type: "النوع",
      price: "السعر",
      register: "تسجيل",
      soldOut: "مبيع بالكامل",
      info: "اختر خطتك واستمر بالضغط على زر التسجيل بإدخال تفاصيلك الشخصية",
      available_seats: "التوافر",
      no_limit: "لا حد",
      attendee_not_found: "لم نتمكن من العثور على أي سجل باستخدام البريد الإلكتروني المقدم.",
      unable_to_modify: "نعتذر، المنظم لا يسمح بتحديث التسجيل الخاص بك.",
      general_error: "لم يتمكن البريد من الإرسال. حاول مرة أخرى لاحقًا.",
      continue_registration: "استمر في التسجيل",
      already_registered_info: "إذا كنت قد سجلت بالفعل في هذه الفعالية وترغب في تعديل معلوماتك، يرجى إدخال عنوان بريدك الإلكتروني.",
      already_registered_title: "هل أنت مسجل بالفعل؟",
      mail_sent: "تم إرسال رابط لتعديل معلومات تسجيلك إلى بريدك الإلكتروني."
    },
    contact_form: {
      success_message: "تم إرسال الرسالة بنجاح",
      full_name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      message: "رسالة"
    },
    cookie_consent: {
      privacy_policy: "سياسة الخصوصية",
      explanation: "هذا الموقع يخزن الكوكيز على جهاز الكمبيوتر الخاص بك. تُستخدم هذه الكوكيز لتحسين موقعك وتقديم خدمات أكثر تخصيصًا لك، سواء على هذا الموقع أو من خلال وسائل أخرى.",
      block_information: "ستظهر نافذة الحوار في أسفل الصفحة"
    },
    map: {
      not_location: "يرجى تعيين موقع في إعدادات الفعالية."
    },
    buttons: {
      submit: "إرسال",
      onlyEssential: "فقط الأساسية",
      got_it: "حسناً"
    }
  },
  vi: {
    event: {
      date: {
        past_event: "Sự kiện đã qua",
        ongoing_event: "Sự kiện đang diễn ra"
      },
      price: {
        free: "Miễn phí"
      },
      timezone: "Múi giờ: {{timezone}}"
    },
    workshops: {
      activities: "Hoạt động",
      speakers: "Diễn giả",
      speaker: "Diễn giả",
      schedule: "Lịch trình",
      selectCategory: "Chọn một danh mục",
      category: "Danh mục"
    },
    sponsors: {
      companyDescription: "Mô tả công ty",
      modalTitle: "Thông tin nhà tài trợ",
      title: "Nhà tài trợ"
    },
    speakers: {
      keywords: "Từ khóa",
      noSpeakers: "Không có diễn giả",
      empty_bio: "Diễn giả không có tiểu sử."
    },
    b2b: {
      create_conference_and_participant: "Xin vui lòng tạo một hội nghị và ít nhất một người tham dự"
    },
    text: {
      see_less: "Xem ít hơn",
      read_more: "Đọc thêm",
      less_info: "Ít thông tin hơn",
      more_info: "Nhiều thông tin hơn",
      click_here_file: "Nhấn vào đây để xem tệp",
      no_iframe_src: "Vui lòng đặt URL cho iframe"
    },
    date: {
      available_date: "Ngày khả dụng",
      to: "đến",
      starts_at: "Bắt đầu lúc",
      ends_at: "Kết thúc lúc",
      from_optional: "",
      units: {
        plural: {
          days: "ngày",
          hours: "giờ",
          minutes: "phút",
          seconds: "giây"
        }
      }
    },
    exhibitors: {
      search: "tìm kiếm",
      reset: "đặt lại"
    },
    registration: {
      sign_up: "Đăng ký",
      type: "Loại",
      price: "Giá",
      register: "Đăng ký",
      soldOut: "Hết chỗ",
      info: "Chọn gói của bạn và tiếp tục vào nút đăng ký bằng cách nhập thông tin cá nhân của bạn",
      available_seats: "Số chỗ có sẵn",
      no_limit: "Không giới hạn",
      attendee_not_found: "Chúng tôi không tìm thấy bất kỳ hồ sơ nào với email đã cung cấp.",
      unable_to_modify: "Xin lỗi, người tổ chức không cho phép cập nhật đăng ký của bạn.",
      general_error: "Email không thể được gửi. Vui lòng thử lại sau.",
      continue_registration: "Tiếp tục đăng ký",
      already_registered_info: "Nếu bạn đã đăng ký cho sự kiện này và muốn chỉnh sửa thông tin của mình, vui lòng nhập địa chỉ email của bạn.",
      already_registered_title: "Đã đăng ký chưa?",
      mail_sent: "Một liên kết để chỉnh sửa thông tin đăng ký của bạn đã được gửi đến email của bạn."
    },
    contact_form: {
      success_message: "Tin nhắn đã được gửi thành công",
      full_name: "Họ và tên",
      email: "Email",
      message: "Tin nhắn"
    },
    cookie_consent: {
      privacy_policy: "Chính sách quyền riêng tư",
      explanation: "Trang web này lưu trữ cookie trên máy tính của bạn. Các cookie này được sử dụng để cải thiện trang web của bạn và cung cấp dịch vụ cá nhân hóa hơn cho bạn, cả trên trang web này và qua các phương tiện khác.",
      block_information: "Hộp modal sẽ được hiển thị ở cuối trang"
    },
    map: {
      not_location: "Vui lòng chỉ định một địa điểm trong cấu hình sự kiện."
    },
    buttons: {
      submit: "Gửi",
      onlyEssential: "Chỉ những cái cần thiết",
      got_it: "Hiểu rồi"
    }
  },
  zh: {
    event: {
      date: {
        past_event: "过去的事件",
        ongoing_event: "进行中的事件"
      },
      price: {
        free: "免费"
      },
      timezone: "时区：{{timezone}}"
    },
    workshops: {
      activities: "活动",
      speakers: "演讲者",
      speaker: "演讲者",
      schedule: "日程",
      selectCategory: "选择一个类别",
      category: "类别"
    },
    sponsors: {
      companyDescription: "公司描述",
      modalTitle: "赞助商信息",
      title: "赞助商"
    },
    speakers: {
      keywords: "关键词",
      noSpeakers: "没有演讲者",
      empty_bio: "该演讲者没有传记。"
    },
    b2b: {
      create_conference_and_participant: "请创建会议并至少添加一个参与者"
    },
    text: {
      see_less: "查看较少",
      read_more: "阅读更多",
      less_info: "较少信息",
      more_info: "更多信息",
      click_here_file: "点击这里查看文件",
      no_iframe_src: "请为iframe设置链接"
    },
    date: {
      available_date: "可用日期",
      to: "到",
      starts_at: "开始于",
      ends_at: "结束于",
      from_optional: "",
      units: {
        plural: {
          days: "天",
          hours: "小时",
          minutes: "分钟",
          seconds: "秒"
        }
      }
    },
    exhibitors: {
      search: "搜索",
      reset: "重置"
    },
    registration: {
      sign_up: "注册",
      type: "类型",
      price: "价格",
      register: "注册",
      soldOut: "售罄",
      info: "选择您的计划并通过输入您的个人信息继续点击注册按钮",
      available_seats: "可用座位",
      no_limit: "无限制",
      attendee_not_found: "未找到提供的电子邮件记录。",
      unable_to_modify: "抱歉，组织者不允许对您的注册进行更新。",
      general_error: "邮件无法发送。请稍后再试。",
      continue_registration: "继续注册",
      already_registered_info: "如果您已经注册了该活动并想编辑您的信息，请输入您的电子邮件地址。",
      already_registered_title: "已经注册？",
      mail_sent: "编辑您的注册信息的链接已发送到您的电子邮件。"
    },
    contact_form: {
      success_message: "消息已成功发送",
      full_name: "全名",
      email: "电子邮件",
      message: "消息"
    },
    cookie_consent: {
      privacy_policy: "隐私政策",
      explanation: "本网站在您的计算机上存储cookie。这些cookie用于改善您的网站并提供更个性化的服务，无论是在本网站还是通过其他媒体。",
      block_information: "模态框将在页面底部显示"
    },
    map: {
      not_location: "请在活动设置中分配一个位置。"
    },
    buttons: {
      submit: "提交",
      onlyEssential: "仅必需",
      got_it: "了解"
    }
  },
  "zh-TW": {
    event: {
      date: {
        past_event: "過去的活動",
        ongoing_event: "進行中的活動"
      },
      price: {
        free: "免費"
      },
      timezone: "時區: {{timezone}}"
    },
    workshops: {
      activities: "活動",
      speakers: "講者",
      speaker: "講者",
      schedule: "日程",
      selectCategory: "選擇類別",
      category: "類別"
    },
    sponsors: {
      companyDescription: "公司介紹",
      modalTitle: "贊助商資訊",
      title: "贊助商"
    },
    speakers: {
      keywords: "關鍵詞",
      noSpeakers: "沒有講者",
      empty_bio: "該講者沒有傳記。"
    },
    b2b: {
      create_conference_and_participant: "請創建一個會議和至少一個參與者"
    },
    text: {
      see_less: "查看較少",
      read_more: "閱讀更多",
      less_info: "較少資訊",
      more_info: "更多資訊",
      click_here_file: "點擊此處查看檔案",
      no_iframe_src: "請設定 iframe 的網址"
    },
    date: {
      available_date: "可用日期",
      to: "至",
      starts_at: "開始於",
      ends_at: "結束於",
      from_optional: "",
      units: {
        plural: {
          days: "天",
          hours: "小時",
          minutes: "分鐘",
          seconds: "秒"
        }
      }
    },
    exhibitors: {
      search: "搜尋",
      reset: "重置"
    },
    registration: {
      sign_up: "註冊",
      type: "類型",
      price: "價格",
      register: "註冊",
      soldOut: "已售完",
      info: "選擇您的計劃並通過輸入個人資料繼續按註冊按鈕",
      available_seats: "可用座位",
      no_limit: "無限制",
      attendee_not_found: "我們找不到提供的電子郵件記錄。",
      unable_to_modify: "抱歉，主辦方不允許更新您的註冊。",
      general_error: "郵件無法發送。請稍後再試。",
      continue_registration: "繼續註冊",
      already_registered_info: "如果您已經註冊了此活動並想要編輯您的資訊，請輸入您的電子郵件地址。",
      already_registered_title: "已經註冊了嗎？",
      mail_sent: "已向您的電子郵件發送了一個鏈接以編輯您的註冊資訊。"
    },
    contact_form: {
      success_message: "訊息已成功發送",
      full_name: "全名",
      email: "電子郵件",
      message: "訊息"
    },
    cookie_consent: {
      privacy_policy: "隱私政策",
      explanation: "本網站在您的電腦上存儲Cookie。這些Cookies用於改善您的網站體驗並提供更個性化的服務，無論是在本網站上還是通過其他媒體。",
      block_information: "模態框將顯示在頁面底部"
    },
    map: {
      not_location: "請在活動配置中指定一個位置。"
    },
    buttons: {
      submit: "提交",
      onlyEssential: "僅限必要",
      got_it: "了解"
    }
  },
  ko: {
    event: {
      date: {
        past_event: "지난 이벤트",
        ongoing_event: "진행 중인 이벤트"
      },
      price: {
        free: "무료"
      },
      timezone: "시간대: {{timezone}}"
    },
    workshops: {
      activities: "활동",
      speakers: "발표자",
      speaker: "발표자",
      schedule: "일정",
      selectCategory: "카테고리 선택",
      category: "카테고리"
    },
    sponsors: {
      companyDescription: "회사 설명",
      modalTitle: "스폰서 정보",
      title: "스폰서"
    },
    speakers: {
      keywords: "키워드",
      noSpeakers: "발표자가 없습니다",
      empty_bio: "발표자에게 이력이 없습니다."
    },
    b2b: {
      create_conference_and_participant: "컨퍼런스와 최소 한 명의 참가자를 생성하십시오."
    },
    text: {
      see_less: "덜 보기",
      read_more: "더 보기",
      less_info: "정보 적음",
      more_info: "정보 많음",
      click_here_file: "파일 보려면 클릭하세요",
      no_iframe_src: "iframe의 URL을 설정하십시오."
    },
    date: {
      available_date: "가능한 날짜",
      to: "에서",
      starts_at: "시작 시간",
      ends_at: "종료 시간",
      from_optional: "",
      units: {
        plural: {
          days: "일",
          hours: "시간",
          minutes: "분",
          seconds: "초"
        }
      }
    },
    exhibitors: {
      search: "검색",
      reset: "초기화"
    },
    registration: {
      sign_up: "가입하기",
      type: "유형",
      price: "가격",
      register: "등록",
      soldOut: "매진",
      info: "계획을 선택하고 개인 정보를 입력하여 가입 버튼에서 계속 진행하십시오.",
      available_seats: "가용 좌석",
      no_limit: "제한 없음",
      attendee_not_found: "제공된 이메일로 된 기록을 찾을 수 없습니다.",
      unable_to_modify: "죄송합니다, 주최자가 귀하의 등록 정보를 업데이트하는 것을 허용하지 않습니다.",
      general_error: "메일을 보낼 수 없습니다. 나중에 다시 시도하십시오.",
      continue_registration: "등록 계속하기",
      already_registered_info: "이 이벤트에 이미 등록하신 경우 정보를 수정하려면 이메일 주소를 입력하십시오.",
      already_registered_title: "이미 등록하셨습니까?",
      mail_sent: "등록 정보 편집 링크가 귀하의 이메일로 발송되었습니다."
    },
    contact_form: {
      success_message: "메시지가 성공적으로 전송되었습니다.",
      full_name: "전체 이름",
      email: "이메일",
      message: "메시지"
    },
    cookie_consent: {
      privacy_policy: "개인정보 처리방침",
      explanation: "이 웹사이트는 귀하의 컴퓨터에 쿠키를 저장합니다. 이러한 쿠키는 귀하의 웹사이트를 개선하고 이 웹사이트와 다른 매체를 통해 개인화된 서비스를 제공하기 위해 사용됩니다.",
      block_information: "모달 박스는 페이지 하단에 표시됩니다."
    },
    map: {
      not_location: "이벤트 구성에서 위치를 지정하십시오."
    },
    buttons: {
      submit: "제출",
      onlyEssential: "필수 항목만",
      got_it: "알겠습니다."
    }
  },
  ja: {
    event: {
      date: {
        past_event: "過去のイベント",
        ongoing_event: "進行中のイベント"
      },
      price: {
        free: "無料"
      },
      timezone: "タイムゾーン: {{timezone}}"
    },
    workshops: {
      activities: "アクティビティ",
      speakers: "スピーカー",
      speaker: "スピーカー",
      schedule: "スケジュール",
      selectCategory: "カテゴリーを選択",
      category: "カテゴリー"
    },
    sponsors: {
      companyDescription: "会社の説明",
      modalTitle: "スポンサー情報",
      title: "スポンサー"
    },
    speakers: {
      keywords: "キーワード",
      noSpeakers: "スピーカーがいません",
      empty_bio: "スピーカーの経歴はありません。"
    },
    b2b: {
      create_conference_and_participant: "カンファレンスと少なくとも1人の参加者を作成してください"
    },
    text: {
      see_less: "少なく見る",
      read_more: "もっと読む",
      less_info: "情報が少ない",
      more_info: "もっと情報",
      click_here_file: "こちらをクリックしてファイルを表示",
      no_iframe_src: "iframeのURLを設定してください"
    },
    date: {
      available_date: "利用可能な日付",
      to: "まで",
      starts_at: "開始時刻",
      ends_at: "終了時刻",
      from_optional: "",
      units: {
        plural: {
          days: "日",
          hours: "時間",
          minutes: "分",
          seconds: "秒"
        }
      }
    },
    exhibitors: {
      search: "検索",
      reset: "リセット"
    },
    registration: {
      sign_up: "サインアップ",
      type: "タイプ",
      price: "価格",
      register: "登録",
      soldOut: "売り切れ",
      info: "プランを選択し、個人情報を入力してサインアップボタンを続行してください",
      available_seats: "空き状況",
      no_limit: "制限なし",
      attendee_not_found: "提供されたメールでの記録は見つかりませんでした。",
      unable_to_modify: "申し訳ありませんが、主催者は登録の更新を許可していません。",
      general_error: "メールを送信できませんでした。後でもう一度お試しください。",
      continue_registration: "登録を続ける",
      already_registered_info: "このイベントにすでに登録していて情報を編集したい場合は、メールアドレスを入力してください。",
      already_registered_title: "すでに登録済み？",
      mail_sent: "登録情報を編集するためのリンクがメールに送信されました。"
    },
    contact_form: {
      success_message: "メッセージは正常に送信されました",
      full_name: "フルネーム",
      email: "メール",
      message: "メッセージ"
    },
    cookie_consent: {
      privacy_policy: "プライバシーポリシー",
      explanation: "このウェブサイトは、あなたのコンピュータにクッキーを保存します。これらのクッキーは、あなたのウェブサイトを改善し、あなたによりパーソナライズされたサービスを提供するために使用されます。",
      block_information: "モーダルボックスはページの下部に表示されます"
    },
    map: {
      not_location: "イベント設定で位置を指定してください。"
    },
    buttons: {
      submit: "送信",
      onlyEssential: "必要最低限のもののみ",
      got_it: "了解しました"
    }
  }
};